/** Слой плинтусов: назначение материала и локальные настройки для каждой комнаты. */
import { create } from "zustand";
import { BaseboardMaterial } from "@/shared/catalog";
import type { RoomBaseboard } from "@/shared/plan";

interface BaseboardLayerState {
	items: Record<string, RoomBaseboard>;
	visible: boolean;
	setRoomBaseboardMaterial: (roomId: string, material: BaseboardMaterial) => void;
	updateRoomBaseboard: (
		roomId: string,
		patch: Partial<Pick<RoomBaseboard, "height" | "color">>,
	) => void;
	removeRoomBaseboard: (roomId: string) => void;
	setVisible: (visible: boolean) => void;
	toggleVisible: () => void;
	restoreBaseboards: (items: Record<string, RoomBaseboard>) => void;
}

export const useBaseboardStore = create<BaseboardLayerState>((set) => ({
	items: {},
	visible: true,
	setRoomBaseboardMaterial: (roomId, material) =>
		set((state) =>
			state.items[roomId]?.material === material
				? state
				: { items: { ...state.items, [roomId]: { id: roomId, roomId, material } } },
		),
	updateRoomBaseboard: (roomId, patch) =>
		set((state) => {
			const baseboard = state.items[roomId];
			return baseboard
				? { items: { ...state.items, [roomId]: { ...baseboard, ...patch } } }
				: state;
		}),
	removeRoomBaseboard: (roomId) =>
		set((state) => {
			if (!state.items[roomId]) return state;
			const items = { ...state.items };
			delete items[roomId];
			return { items };
		}),
	setVisible: (visible) => set({ visible }),
	toggleVisible: () => set((state) => ({ visible: !state.visible })),
	restoreBaseboards: (items) => set({ items }),
}));
